//@ts-nocheck
import { createContext } from 'react';
const AppContext = createContext<AppContext>();
export default AppContext;